import { CSSProperties } from "react";

import { useTheme } from "@hooks";
import { spacing } from "@layout";

export const useStyles = () => {
  const { theme } = useTheme();

  const footerTheme = theme.chart.performance.footer;

  const styles: Record<string, CSSProperties> = {
    container: {
      justifyContent: "space-around",
    },
    item: {
      padding: spacing.m,
      userSelect: "none",
    },
    selectedItem: {
      userSelect: "none",
      padding: spacing.m,
      backgroundColor: footerTheme.selected.background,
      borderRadius: 4,
    },
    text: {
      fontSize: 11,
      fontWeight: 500,
    },
    selectedText: {
      fontSize: 11,
      fontWeight: 500,
      color: footerTheme.selected.text,
    },
    disabled: {
      color: footerTheme.disabled.text,
    },
  };

  return styles;
};
